import { render, staticRenderFns } from "./recommendPolling.vue?vue&type=template&id=bdacb480&scoped=true&"
import script from "./recommendPolling.vue?vue&type=script&lang=js&"
export * from "./recommendPolling.vue?vue&type=script&lang=js&"
import style0 from "./recommendPolling.vue?vue&type=style&index=0&id=bdacb480&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdacb480",
  null
  
)

export default component.exports